// Vendor
import $ from 'jquery';
import Hammer from 'hammerjs';
import Helpers from 'helpers/util';
import { TweenLite } from 'gsap';
import 'gsap/ScrollToPlugin';

class NavCarousel {
	constructor(el) {
		this.$el = $(el);
		this.$outer = this.$el.find('.nav-carousel-outer');
		this.$scroll = this.$el.find('> div');
		this.$containerRow = this.$el.find('.nav-carousel-cont');
		this.$item = this.$el.find('.nav-carousel-cont > li');
		this.$controls = this.$el.find('.nav-carousel__controls');

		this.clsControlRight = '.controls-arrow--right';
		this.clsHidden = 'hidden';
		this.clsVisible = 'visible';
		this.curDown = false;
		this.curYPos = 0;
		this.curXPos = 0;
		this.isDragging = false;
		this.stepW = 0;

		this.doLayout();

		Helpers.pubsub.subscribe('onWindowResize', () => {
			this.doLayout();
		});

		if (!window.Modernizr.touch) {
			this.attachEvents();
			// this.$outer.addClass('is-draggable');
		}

		if (this.$controls.length) {
			this.controlsEvents();
		}
	}

	doLayout() {
		const height = this.$item.eq(0).outerHeight();
		this.$el.height(height);

		this.setSteps();
	}

	attachEvents() {
		const hammertime = new Hammer(this.$scroll.get(0));

		hammertime.on('panleft panright', ev => {
			this.isDragging = true;
			if ($(ev.target).is('li')) {
				this.$scroll.scrollLeft(this.curXPos - ev.deltaX);
			}
		});

		this.$el.on('mousedown', () => {
			this.curDown = true;
			this.isDragging = false;
			this.curXPos = this.$scroll.scrollLeft();
		});

		this.$el.on('mouseup', () => {
			this.curDown = false;

			if (!this.isDragging) {
				const $links = this.$item.find('a');

				if ($links.length) {
					$links.parent().on('click', e => {
						let $el = $(e.currentTarget);
						const href = $el.find('a').attr('href');
						location.href = href;
					});
				}
			}
		});
	}

	getAfterPseudo() {
		return window
			.getComputedStyle(this.$containerRow[0], ':after')
			.getPropertyValue('width');
	}

	controlsEvents() {
		Helpers.pubsub.subscribe('onWindowResize', () => {
			this.setSteps();
		});

		const $arrows = this.$controls.find('.controls-arrow');
		$arrows.on('click', evt => {
			this.controlsClickHandler(evt);
		});
	}

	setSteps() {
		this.steps = [0];

		this.$item.each((i, el) => {
			const step = el.offsetLeft + el.clientWidth;
			this.steps.push(step);
		});

		// hide or show controls
		const outer = step => {
			return step > this.$outer.width();
		};

		const $arrows = this.$controls.find('.controls-arrow');

		if (!this.steps.some(outer)) {
			$arrows.addClass('hidden');
		} else {
			$arrows.removeClass('hidden');
		}
	}

	controlsClickHandler(evt) {
		const $element = $(evt.currentTarget);
		const direction = $element.hasClass('controls-arrow--right')
			? 'next'
			: 'prev';

		const currentX = this.$outer.scrollLeft();

		let scrollX;
		if (direction === 'next') {
			scrollX = this.steps.find(v => v > currentX);
		} else {
			scrollX = this.steps.find(v => v >= currentX - this.stepW);
		}

		if (scrollX === this.stepW) {
			this.$controls.find(this.clsControlRight).addClass(this.clsHidden);
		} else {
			this.$controls
				.find(this.clsControlRight)
				.removeClass(this.clsHidden);
		}

		TweenLite.to(this.$outer, 0.5, { scrollTo: { x: scrollX } });
		this.stepW = scrollX;
	}
}

const _init = () => {
	// Elements
	let $el = $('.js-nav-carousel');
	if ($el.length) {
		new NavCarousel($el);
	}
};

_init();
